import {   useQuery } from "@tanstack/react-query";
import {  getStatistics } from "../api";


export const useGetStatistics = (type) => {
  const {data, isLoading, isError, error, isSuccess} = useQuery({
    queryKey: ['statistics', type],
    queryFn: () => getStatistics(type),
  });

  return {data, isLoading, isSuccess, isError, error};
};

